import { model as i18n } from '!/i18n'
import { api } from '@setplex/tria-api'

import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import type { UiShowBundleWithContent, UiTvShowBundleInfo } from './index.h'
import { formatBundleRowWithContent, formatBundleWithContent } from './lib'

export const $showBundleWithContentFormatted: Store<UiShowBundleWithContent | null> =
  combine(
    api.showBundles.$showBundleWithContent,
    ssePurchasesModel.$tvShow,
    ssePurchasesModel.$tvShowSet,
    i18n.$t,
    (content, adjustShow, adjustSet, { t }) =>
      formatBundleWithContent(content, adjustShow, adjustSet, t)
  )

export const $showBundlesRowFormatted: Store<UiTvShowBundleInfo[]> = combine(
  api.showBundles.$showBundlesRow,
  ssePurchasesModel.$tvShowSet,
  i18n.$t,
  (showBundles, adjust, { t }) =>
    showBundles.map(formatBundleRowWithContent(t, adjust))
)

export const $showBundlesRowTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('extras')
)
